import React from "react";
import Header from "../component/Header";
import Footer from "./footer";
import Chart from "../component/Chart";

function Dashboard() {
  return (
    <>
      <Header />

      <Chart />
      <Footer />
    </>
  );
}

export default Dashboard;
